import * as Highcharts from 'highcharts';

import 'highcharts/highcharts-more';
import HighchartsMore from 'highcharts/highcharts-more';
import Streamgraph from 'highcharts/modules/streamgraph';
import SeriesLabel from 'highcharts/modules/series-label';

HighchartsMore(Highcharts);
Streamgraph(Highcharts);
SeriesLabel(Highcharts);

export class Charts {
	public static readonly PortfolioStream: Highcharts.Options = {
		chart: {
			type: 'streamgraph',
			zoomType: 'x',
			style: {
				fontFamily: 'PT Sans'
			}
		},

		colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066',
			'#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],

		credits: {
			enabled: false
		},

		title: {
			floating: true,
			align: 'left',
			text: ''
		},

		xAxis: {
			type: 'category',
			lineWidth: 0,
			tickWidth: 0,
			labels: {
				reserveSpace: true,
				rotation: 270
			}
		},

		yAxis: {
			visible: false,
			startOnTick: false,
			endOnTick: false
		},

		legend: {
			enabled: false
		},

		plotOptions: {
			series: {
				dataLabels: {
					style: {
						color: 'rgba(255,255,255,0.75)'
					}
				}
			}
		},

		exporting: {
			enabled: false,
			sourceWidth: 800,
			sourceHeight: 600
		}
	};

	public static readonly MiniChart: Highcharts.Options = {
		chart: {
			type: 'column',
			zoomType: 'x',
			style: {
				fontFamily: 'Source Sans Pro'
			}
		},

		colors: ['#8f1e5e'],

		credits: {
			enabled: false
		},

		title: {
			floating: true,
			align: 'left',
			text: ''
		},

		tooltip: {
			followPointer: true,
			pointFormat: '<b>${point.y:,.0f}</b>'
		},

		xAxis: {
			type: 'category',
			lineWidth: 0,
			tickWidth: 0,
			gridLineWidth: 1,
			labels: {
				reserveSpace: true,
				rotation: 270
			}
		},

		yAxis: {
			visible: false,
			startOnTick: false,
			endOnTick: false
		},

		legend: {
			enabled: false
		},

		plotOptions: {
			series: {
				dataLabels: {
					enabled: false
				}
			},
			column: {
				pointPadding: 0,
				groupPadding: 0.05,
				states: {
					hover: {
						color: "#0b87c9"
					}
				}
			}
		},

		exporting: {
			enabled: false,
			sourceWidth: 800,
			sourceHeight: 600
		}
	};

	public static readonly MiniChartLine: Highcharts.Options = {
		chart: {
			type: 'line',
			zoomType: 'x',
			style: {
				fontFamily: 'Source Sans Pro'
			}
		},

		colors: ['#79be4b'],

		credits: {
			enabled: false
		},

		title: {
			floating: true,
			align: 'left',
			text: ''
		},

		tooltip: {
			pointFormat: '<b>{point.y:,.1f}%</b>'
		},

		xAxis: {
			type: 'category',
			lineWidth: 0,
			tickWidth: 0,
			gridLineWidth: 1,
			labels: {
				reserveSpace: true,
				rotation: 270
			}
		},

		yAxis: {
			visible: false,
			startOnTick: false,
			endOnTick: false
		},

		legend: {
			enabled: false
		},

		plotOptions: {
			series: {
				dataLabels: {
					enabled: false
				},
				label: {
					enabled: false
				},
				marker: {
					lineWidth: 1.5
				}
			}
		},

		exporting: {
			enabled: false,
			sourceWidth: 800,
			sourceHeight: 600
		}
	};

	public static readonly CategoryPie: Highcharts.Options = {
		chart: {
			type: 'pie',
			plotShadow: false,
			plotBackgroundColor: undefined,
			plotBorderWidth: undefined,
			spacing: [0, 0, 0, 0]
		},
		tooltip: {
			pointFormat: '<b>${point.y:,.0f}</b> - {point.percentage:.1f}%'
		},

		colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066',
			'#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],

		credits: {
			enabled: false
		},

		legend: {
			enabled: false
		},

		plotOptions: {
			pie: {
				shadow: false,
				innerSize: '80%',
				dataLabels: {
					distance: 15,
					padding: 0
				}
			}
		},

		exporting: {
			enabled: false,
			sourceWidth: 800,
			sourceHeight: 600
		}
	};

	public static readonly MetricsChart: Highcharts.Options = {
		chart: {
			type: 'line',
			style: {
				fontFamily: 'PT Sans'
			}
		},

		title: {
			text: ""
		},

		colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066',
			'#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],

		xAxis: {
			type: 'category'
		},

		legend: {
			enabled: true
		},

		tooltip: {
			shared: true,
			crosshairs: true
		},

		plotOptions: {
			series: {
				dataLabels: {
					enabled: true
				},
				label: {
					enabled: false
				}
			}
		},

		exporting: {
			enabled: false,
			sourceWidth: 800,
			sourceHeight: 600
		}
	};
}
